module.exports = __webpack_public_path__ + "img/trash.ad9e9025.svg";